import React, {createContext, useContext, useState} from 'react';

interface IWizardProgressContext {
  currentStep: number;
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
}

const WizardProgressContext = createContext<IWizardProgressContext | null>(1);
const WizardMaxPage = createContext<number>(1);

export const WizardProgressProvider = ({numberOfPages, children}) => {
  const [currentStep, setCurrentStep] = useState<number>(1);
  const api = {currentStep, setCurrentStep};

  return (
    <WizardMaxPage.Provider value={numberOfPages}>
      <WizardProgressContext.Provider value={api}>
        {children}
      </WizardProgressContext.Provider>
    </WizardMaxPage.Provider>
  );
};

export const useWizardProgress = () => useContext(WizardProgressContext);
export const useWizardMaxPage = () => useContext(WizardMaxPage);